import axios from "./AxiosInstance"

const GetLastAppUpdated = () => axios.get(`version.json`)

export const AppUpdateService = { GetLastAppUpdated }
